const changePathName = (router, pathname) => {
  const locationSearchParams = Object.fromEntries(new URLSearchParams(window.location.search));
  let { query } = router;
  query = Object.keys(query).length ? query : { ...query, ...locationSearchParams };
  router.push({ pathname, query });
};

export default changePathName;
